import API from "../../api";
import {API_UPDATE_INSPECTION, API_CHANGE_MACHINE_INSPECTION} from "../../constants/api";

const getInformationInspection = async (inspectionId) => {
  try {
    const response = await API.get(API_UPDATE_INSPECTION(inspectionId));
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const update = async (inspectionId, data) => {
  try {
    const response = await API.post(API_UPDATE_INSPECTION(inspectionId), data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const changeMachineSelect = async (inspectionId, data) => {
  try {
    const response = await API.get(API_CHANGE_MACHINE_INSPECTION(inspectionId), {
      params: data
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const changeMachineInput = async (inspectionId, data) => {
  try {
    const response = await API.post(API_CHANGE_MACHINE_INSPECTION(inspectionId), data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const UpdateInspection = {
  getInformationInspection,
  changeMachineSelect,
  changeMachineInput,
  update
};

export {
  UpdateInspection as default,
  getInformationInspection,
  changeMachineSelect,
  changeMachineInput,
  update
}